export const TEXTS = {
  MODAL_TITLE: 'Телевизор',
  TITLE_DESCRIPTION:
    'Подключите ваш аккаунт со всеми настройками — для этого введите код из приложения «Звук Бизнес» на телевизоре',

  CODE_BIND_TITLE: 'Код из приложения',
  CODE_BIND_PLACEHOLDER: '4 символа',

  SUCCESS_BUTTON: 'Привязать устройство',
  CANCEL_BUTTON: 'Назад',
};
